import { EncounterType } from '@hb/shared'
import { useMemo } from 'react'
import { useGynCareView } from '../../../components/Gyn/context'
import { useProfile } from '../../../contexts/user/ProfileContext'
import { EncounterListProviderProps } from './context'

export const useProfileEncounterPracticeId = (type: EncounterType) => {
  const { practiceId: gynPracticeId } = useGynCareView()
  const {
    selectedAssessment: { populated: assessment },
  } = useProfile()
  return useMemo(() => {
    switch (type) {
      case EncounterType.ANTEPARTUM:
      case EncounterType.POSTPARTUM:
      case EncounterType.BIRTHING_CENTER_ADMISSION:
        return assessment?.midwifeId ?? null
      default:
        return gynPracticeId
    }
  }, [type, gynPracticeId, assessment])
}

export type UseProfileEncounterListProps<T extends EncounterType> = Omit<
  EncounterListProviderProps<T>,
  'onOpenExam'
>

export const useProfileEncounterListProps = <T extends EncounterType>(
  type: T,
): UseProfileEncounterListProps<T> => {
  const practiceId = useProfileEncounterPracticeId(type)
  const { userId: patientId, encounters: patientEncountersData } = useProfile()
  return {
    type,
    practiceId,
    patientEncountersData,
    patientId,
  }
}
